import React, { ReactElement } from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    buildPopupConfigurationSummaryItems,
    PopupConfigurationSummarySegmentType,
} from './MarkersOfHarmPopupConfigurationSummary.mappers';
import { MarkersOfHarmPopupFormState } from './MarkersOfHarmPopupForm.state';
import {
    PopupAppliedActionFormValueType,
    PopupAppliedActionRestrictionPeriodFormValueType,
    PopupRiskLevelType,
} from './MarkersOfHarmPopupTab.types';

const renderSummarySegment = (segment: PopupConfigurationSummarySegmentType, index: number): ReactElement => {
    if (typeof segment === 'string') {
        return <React.Fragment key={index}>{segment}</React.Fragment>;
    }

    return <em key={index}>{segment.text}</em>;
};

type MarkersOfHarmPopupConfigurationSummaryPropsType = {
    formState: MarkersOfHarmPopupFormState;
    appliedAction: PopupAppliedActionFormValueType;
    appliedActionRestrictionPeriod: PopupAppliedActionRestrictionPeriodFormValueType;
    riskLevel: PopupRiskLevelType;
};

export const MarkersOfHarmPopupConfigurationSummary = observer(
    'MarkersOfHarmPopupConfigurationSummary',
    ({
        formState,
        appliedAction,
        appliedActionRestrictionPeriod,
        riskLevel,
    }: MarkersOfHarmPopupConfigurationSummaryPropsType): ReactElement => {
        const summaryItems = buildPopupConfigurationSummaryItems({
            triggerTemplateLabel: formState.triggerTemplateSummaryLabel,
            triggerParamValues: formState.triggerParamSummaryValues,
            appliedAction,
            appliedActionRestrictionPeriod,
            riskLevel,
            hasUnsavedChanges: formState.hasUnsavedChanges,
        });

        return (
            <div
                className='rounded-md bg-[#F4F4F5] p-4'
                data-test='markers-of-harm-popup-configuration-summary'
            >
                <ul className='m-0 flex list-disc flex-col gap-2 pl-5 text-sm text-muted-foreground'>
                    {summaryItems.map((item) => (
                        <li
                            key={item.id}
                            data-test={`markers-of-harm-popup-configuration-summary-${item.id}`}
                        >
                            {item.segments.map((segment, index) => renderSummarySegment(segment, index))}
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
);
